import api from './api';
import type { ConnectEnvironment } from './connectFeedback';

/** Plus state of a Connect app user's couple, from /admin/billing/plus-access. */
export interface PlusAccessStatus {
  email: string;
  uid: string;
  coupleId: string | null;
  isPaired: boolean;
  hasPlus: boolean;
  entitlementState: string | null;
  /** True when Plus comes from an admin grant, so Revoke can remove it. */
  adminGranted: boolean;
}

export const getPlusAccess = async (
  env: ConnectEnvironment,
  email: string,
): Promise<PlusAccessStatus> => {
  const response = await api.get('/api/connect-plus-access', { params: { env, email } });
  return response.data.data;
};

export const setPlusAccess = async ({
  env,
  email,
  active,
}: {
  env: ConnectEnvironment;
  email: string;
  active: boolean;
}): Promise<PlusAccessStatus> => {
  const response = await api.post('/api/connect-plus-access', { env, email, active });
  return response.data.data;
};
